import { VERIFIED_INVOICE_COMMENT_REPORT_ROUTES } from "./invoiceCommentCapabilities";
export function containsInvoiceComments(value, seen = new WeakSet()) {
  if (!value || typeof value !== "object" || value instanceof Date || seen.has(value)) return false;
  seen.add(value);
  if (value.commentOnly === true || value.lineType === "comment") return true;
  return Object.values(value).some(child => containsInvoiceComments(child, seen));
}
export function assertInvoiceCommentReportSupport(data, templateId = "") {
  if (containsInvoiceComments(data) && !VERIFIED_INVOICE_COMMENT_REPORT_ROUTES.includes(templateId)) {
    throw new Error("This report route has not been verified for invoice comments. No report was sent. Use a supported local pricing export or contact your administrator before retrying.");
  }
}
